export function keys<T extends object, K extends keyof T>(object: T): K[] {
  return Object.keys(object || {}) as K[]
}

export function values<T extends object, V extends T[keyof T]>(object: T): V[] {
  return Object.values(object) as V[]
}
